import React from 'react';
import styles from './MobileRegisteration.module.scss';
import PageLink from 'components/PageLink/PageLink';
type Props = {
  RegisterMyAccountLabel: string;
  redirectionUrl: any;
  RegisterAccountText: string;
};
const MobileRegistration = ({
  redirectionUrl,
  RegisterMyAccountLabel,
  RegisterAccountText,
}: Props) => {
  console.log('Model?.RegisterUrl', redirectionUrl);
  return (
    <div className={styles.wrapper}>
      <div className={styles.registerheader}> {RegisterMyAccountLabel}</div>
      <div>
        <PageLink
          url={redirectionUrl}
          text={RegisterAccountText}
          className={styles.registerbtn}
        />
      </div>
    </div>
  );
};

export default MobileRegistration;
